import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchTypeEnum } from '../../../constants/search.constant';
import { IBadgeModel, IHashtagsModel, IURLPreviewModel } from '../../../models/general.model';
import { IGlobalSearchFilterModel, IGlobalSearchResult } from '../../../models/search.model';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({
    providedIn: 'root',
})
export class GeneralService extends BaseApiService {
    protected override endPoint = '';

    getBadgesListing(): Observable<IBadgeModel[]> {
        const params = {
            page: 1,
            size: 50,
        };

        return this.http.get<IBadgeModel[]>(`${this.fullPath}/badges`, { params });
    }

    getHashtagsListing(): Observable<IHashtagsModel[]> {
        const params = {
            filter: 'tag',
            page: 1,
            size: 10,
        };

        return this.http.get<IHashtagsModel[]>(`${this.fullPath}/search`, { params });
    }

    getURLPreview(url: string): Observable<IURLPreviewModel> {
        const params = {
            url,
        };

        return this.http.get<IURLPreviewModel>(`/url-preview`, { params });
    }

    globalSearch(filter: IGlobalSearchFilterModel, query: string): Observable<IGlobalSearchResult> {
        const params = {
            filter: filter.filter ?? SearchTypeEnum.All,
            criteria: query,
            page: filter.page ?? 1,
            size: filter.size ?? 10,
        };
        return this.http.get<IGlobalSearchResult>(`${this.fullPath}/searchV2`, { params });
    }

    globalSearchSummary(filter: IGlobalSearchFilterModel, query: string): Observable<IGlobalSearchResult> {
        const params = {
            criteria: query,
            page: filter.page ?? 1,
            size: filter.size ?? 10,
        };
        return this.http.get<IGlobalSearchResult>(`${this.fullPath}/searchSummary`, { params });
    }
}
